/**
 * Thin <img> wrapper around the canonical SVG at
 * frontend/public/vynahealth.svg. Keep all visual changes to that
 * file — this component only centralizes the alt text, accessibility
 * attributes, and a default className so callers can `<Logo />`
 * without repeating themselves.
 *
 * Why an <img>: the SVG has hard-coded fills (gradient + white) so
 * it doesn't need `currentColor` or CSS-driven styling. A plain
 * <img> is simpler than vite-plugin-svgr for this case and avoids
 * duplicating the SVG source between the public asset and an
 * inline React copy.
 */
export default function Logo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/vynahealth.svg"
      alt="VynaHealth"
      className={className}
      draggable={false}
    />
  )
}
